import _objectWithoutProperties from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["asFormControl"];
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React, { useState } from 'react';
import { FormControl, FormControlLabel, Switch } from '@material-ui/core';
import PropTypes from 'prop-types';
import HiddenField from './HiddenField';
const Switcher = _ref => {
  let {
    onChange,
    defaultValue,
    name,
    label = null,
    value,
    disabled
  } = _ref;
  const [switchValue, setSwitchValue] = useState(!!defaultValue);
  const handleChange = e => {
    setSwitchValue(e.target.checked);
    onChange && onChange(e.target.checked);
  };
  const control = /*#__PURE__*/React.createElement(Switch, {
    disabled: disabled,
    color: "default",
    checked: value || switchValue,
    onChange: handleChange
  });
  return /*#__PURE__*/React.createElement(FormControl, {
    margin: "normal"
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    control: control,
    label: label || ''
  }), /*#__PURE__*/React.createElement(HiddenField, {
    name: name || '',
    value: switchValue
  }));
};
const SwitchBox = _ref2 => {
  let {
      asFormControl
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded);
  return asFormControl ? /*#__PURE__*/React.createElement(Switcher, props) : /*#__PURE__*/React.createElement(Switch, _extends({}, props, {
    margin: "normal"
  }));
};
SwitchBox.propTypes = {
  name: PropTypes.string,
  label: PropTypes.string,
  required: PropTypes.bool,
  email: PropTypes.bool,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  color: PropTypes.string,
  inputProps: PropTypes.object
};
export default SwitchBox;